import { render, staticRenderFns } from "./ContentCardTags.vue?vue&type=template&id=db945464&scoped=true"
import script from "./ContentCardTags.vue?vue&type=script&lang=js"
export * from "./ContentCardTags.vue?vue&type=script&lang=js"
import style0 from "./ContentCardTags.vue?vue&type=style&index=0&id=db945464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db945464",
  null
  
)

export default component.exports